import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';

const list = createReducer(
  {},
  {
    [ActionTypes.FETCH_QUESTIONS_SUCCESS]: (state, { payload }) =>
      Object.assign({}, state, { [payload.key]: payload.questions })
  }
);

const setStatusForKey = (state, { type, payload }) =>
  Object.assign({}, state, { [payload.key]: type });

const status = createReducer(
  {},
  {
    [ActionTypes.FETCH_QUESTIONS_REQUEST]: setStatusForKey,
    [ActionTypes.FETCH_QUESTIONS_SUCCESS]: setStatusForKey,
    [ActionTypes.FETCH_QUESTIONS_NOT_FOUND]: setStatusForKey,
    [ActionTypes.FETCH_QUESTIONS_ERROR]: setStatusForKey
  }
);

export default combineReducers({
  list,
  status
});
